import React, { useState, useEffect, useRef } from 'react';
import { useWebSocket } from '../contexts/WebSocketContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaBarcode, FaTimes, FaInbox, FaTruck, FaWarehouse } from 'react-icons/fa';
import './ScanNotificationPrompt.css';

export default function ScanNotificationPrompt() {
  const { latestScan } = useWebSocket();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeScan, setActiveScan] = useState(null);
  const lastProcessedRef = useRef(null);

  useEffect(() => {
    if (!latestScan || !latestScan.barcodeData) return;

    // Check if it's a new scan we haven't prompted for yet
    const scanId = latestScan.id || latestScan.timestamp;
    if (lastProcessedRef.current === scanId) return;

    // Save scan ID so we don't prompt again
    lastProcessedRef.current = scanId;

    // Do NOT prompt if the user is already on the scanner page
    if (location.pathname === '/ims-scanner') return;

    // Trigger the prompt popup
    setActiveScan(latestScan);
  }, [latestScan, location.pathname]);

  if (!activeScan) return null;

  const handleAction = (stage) => {
    navigate('/ims-scanner', {
      state: {
        autoScan: true,
        barcode: activeScan.barcodeData,
        deviceName: activeScan.deviceName,
        actionIntent: stage
      }
    });
    setActiveScan(null);
  };

  return (
    <div className="scan-prompt-toast">
      <div className="scan-prompt-header">
        <div className="scan-prompt-title-wrap">
          <FaBarcode className="scan-prompt-icon" />
          <span className="scan-prompt-title">Scan Detected</span>
        </div>
        <button className="scan-prompt-close" onClick={() => setActiveScan(null)}>
          <FaTimes />
        </button>
      </div>
      <div className="scan-prompt-body">
        <strong className="scan-prompt-barcode">{activeScan.barcodeData}</strong>
        <span className="scan-prompt-device">scanned from {activeScan.deviceName || 'ESP32 Device'}</span>
      </div>
      <div className="scan-prompt-actions">
        <button className="btn-prompt-action receive" onClick={() => handleAction('RECEIVE')}>
          <FaInbox /> Receive
        </button>
        <button className="btn-prompt-action dispatch" onClick={() => handleAction('DISPATCH')}>
          <FaTruck /> Dispatch
        </button>
        <button className="btn-prompt-action putaway" onClick={() => handleAction('PUTAWAY')}>
          <FaWarehouse /> Putaway
        </button>
      </div>
    </div>
  );
}
